// extracted by mini-css-extract-plugin
export default {"purchaseModal":"purchase-modal_purchaseModal__ME8xR","includeWallet":"purchase-modal_includeWallet__7HP3h"};